import { TableField } from "../../table-field";
import { CriterioSerigy } from "./criterio-serigy";
import { EnumTipoAnaliseId } from "./enum-tipo-analise-id";

const actions = {
    key: "actions",
    label: "Ações",
    tdClass: ["align-middle", "col-actions", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};
const dimensaoCd: TableField = {
    key: "dimensaoCd",
    label: "ID",
    tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
    formatter: (val: string) => `${val}.`
};
const dimensaoDs: TableField = {
    key: "dimensaoDs",
    label: "Dimensão",
    tdClass: ["align-middle", "quebrarPorPalavra", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const validados: TableField = {
    key: "criterios",
    label: "Validados",
    tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
    formatter: (critetios: CriterioSerigy[]) => {
        const validadoAuditor = critetios.reduce((acc, crit) => {
            if (crit.temRespostaAuditor) acc++
            return acc
        }, 0)
        const qntdCriterios = critetios.length
        return `${validadoAuditor} de ${qntdCriterios} validados`;
    }
};

export const fieldsGeralSerigy: TableField[] = [
    dimensaoCd,
    dimensaoDs,
    validados,
    actions,
];
